import { all, takeLatest, put } from 'redux-saga/effects';
import { RESET_PASSWORD } from './constants';
import { requestResetPassword } from './api';
import { resetPasswordSuccess, resetPasswordFailure } from './actions';

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{obj, type}>>}
 */
function* resetPassword(actionObj) {
    const { resolve, reject } = actionObj;

    try {
        const response = yield requestResetPassword(actionObj.formData);
        if (response.success) {
            yield put(resetPasswordSuccess(response));
            resolve(response);
        } else {
            yield put(resetPasswordFailure(response));
            reject(response);
        }
    } catch (error) {
        console.log("error " + error);
    }
}

/**
 *
 * @returns {IterableIterator<ForkEffect>}
 */
function* watch() {
    yield takeLatest(RESET_PASSWORD, resetPassword);
}

function* resetPasswordSaga() {
    yield all([
        watch()
    ]);
}

export default resetPasswordSaga;